import React, { Fragment } from "react";
import { graphql, useStaticQuery } from "gatsby";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import "../scss/support.scss";

const FormSideBanner = props => {
  const data = useStaticQuery(graphql`
    query bannerInfoQuery {
      gr: strapiComponents(name: { eq: "formSideBanner" }) {
        jsonSchema {
          bannerDescription2
          bannerTitle
          bannerListTitle
          bannerImage
          bannerDescription
          bannerListElements
        }
      }
      rus: strapiComponents(name: { eq: "formSideBannerRUS" }) {
        jsonSchema {
          bannerDescription2
          bannerTitle
          bannerListTitle
          bannerImage
          bannerDescription
          bannerListElements
        }
      }
    }
  `);
  const context = data[props.language];

  return (
    <Fragment>
      <div className="support-section">
        <h3 className="support-section__title text-center">
          {context.jsonSchema.bannerTitle}
        </h3>
        <div className="support-section__banner-wrapper">
          <div className="row mx-0">
            <img
              className="support-section__banner-wrapper-image mx-auto"
              src={context.jsonSchema.bannerImage}
              alt="banner"
            />
          </div>
          <p className="support-section__banner-wrapper-company text-center">
            {context.jsonSchema.bannerDescription2}
          </p>
        </div>
        <hr />
        <div className="support-section__why-us row">
          <div className="col-12">
            <div className="support-section__why-us-title p-0 text-left">
              {context.jsonSchema.bannerListTitle}
            </div>
            <div className="support-section__why-us-content">
              {context.jsonSchema.bannerListElements.map(element => {
                return (
                  <div key={element} className="row content">
                    <div className="col-2 support-section__why-us-content-check-icon">
                      <FontAwesomeIcon icon={faCheck} color="#00c1ff" />
                    </div>
                    <div className="col-10">
                      <p className="support-section__why-us-content-text text-left">
                        {element}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default FormSideBanner;
